// This file will contain code for any modules and common site scripts.
// Build it with npm run build



// Local vendor modules

// needs jquery... ugh
// import slick from './vendors/slick';

require('bootstrap');

// import 'core-js/stable';
// import 'regenerator-runtime/runtime';

import './polyfills';

// Code for components that will be part of CMS templates generally goes in the /modules folder

if(window.document.documentMode) {
	// IE detection

	document.body.className += ' ie';
}

import ieGrid from "./modules/ie-grid.js";

//ieGrid.test();

var grids = document.querySelectorAll(".ie-grid");

if(grids.length > 0)
{
	Array.from(grids).forEach(grid => {
		ieGrid.doIEGrid(
			grid,
			{
				numCols: 3,
				maxRows: 10,
				useGutters: true,
				gridRowTemplate: "260px 20px"
			}
		);		
	});
}


require("./modules/iframe-scale.js").init();
require("./modules/nav.js").init();
require("./modules/contact-form.js").init();
require("./modules/toggle.js").init();
require("./modules/modal.js").init();
require("./modules/locations.js").init();
require("./modules/gated-access.js").init();
require("./modules/animations.js").init();
require("./modules/article-progress.js").init();
require("./modules/placeholder-input.js").init();
require("./modules/tab-system.js").init();
require("./modules/anchor-nav.js").init();
require("./modules/mo2022-header.js").init();
require("./modules/mo2022.js").init();


window.printArticle = function() {
	window.print();
	
	// window.scrollTo({
	//   top: document.body.clientHeight,
	//   behavior: 'smooth'
	// });

	// setTimeout( function() {
	// 	window.print();	
	// }, 500);
}


